var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopRightArrow = function SvgTopRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M21.003 12a9 9 0 0 1-9.001 9 9 9 0 1 1 0-18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m20.552 3.47-5.564 5.54m5.564-5.54c-.495-.496-3.832-.45-4.537-.44m4.537.44c.495.494.449 3.83.439 4.535"
  })));
};
export default SvgTopRightArrow;